// src/services/mealService.js
import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../utils/axiosBaseQuery"; // Assuming the same custom axiosBaseQuery is used
import {
  MEAL_DELETE,
  REVIEW_DETAIL,
  GET_STORE_RATINGS,
  RATINGS_DETAILS,
  RATINGS_STATAUS,
  RATINGS_DELETE,
  REVIEW_UPDATE
} from "../../config/constants"; // Adjust endpoints as per your config

const ratings = createApi({
  reducerPath: "ratings",
  baseQuery: axiosBaseQuery({ baseUrl: "" }), // Use axiosBaseQuery
  tagTypes: ["Ratings"],
  endpoints: (builder) => ({
    getRatings: builder.query({
      query: (bodyData) => ({
        url: GET_STORE_RATINGS,
        method: "POST",
        data: bodyData,
      }),
      providesTags: ["Ratings"],
    }),
    getReviewDetails: builder.query({
      query: (id) => ({
        url: `${REVIEW_DETAIL}/${id}`,
        method: "GET",
      }),
    }),
    getRatingsDetail: builder.query({
      query: (id) => ({
        url: `${RATINGS_DETAILS}/${id}`,
        method: "GET",
      }),
      providesTags: ["ratings"],
    }),
    ratingsStatus: builder.mutation({
      query: ({ id, body }) => ({
        url: `${RATINGS_STATAUS}/${id}`,
        method: "PATCH",
        data: body,
      }),
      providesTags: ["ratings"],
    }),
    updatedRatings: builder.mutation({
      query: ({ id, body }) => ({
        url: `${REVIEW_UPDATE}/${id}`,
        method: "PUT",
        data: body,
      }),
      providesTags: ["ratings"],
    }),
    deleteRatings: builder.mutation({
      query: (id) => ({
        url: `${RATINGS_DELETE}/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Review"],
    }),
  }),
});

// Export hooks for usage in functional components
export const {
  useGetRatingsQuery,
  useGetRatingsDetailQuery,
  useRatingsStatusMutation,
  useUpdatedRatingsMutation,
  useDeleteRatingsMutation,
} = ratings;

// Export the reducer to be included in the store
export default ratings;
